import { setStore, getStore } from '@/utils/tools.js'

export default {
    // 获取用户信息存入vuex
    ['SET_USER_INFO'](state, data) {
        state.userInfo = data ? data : state.userInfo;
    },
    ['UPDATE_CUR_MENU'](state, data) {
        state.curAction = data && data.action ? data.action : '';
        state.curMenuPath = data && data.menuPath ? data.menuPath : '';
    },
    ['SET_ROLE_LIST'](state, data) {
        if (data) {
            if (data.hasOwnProperty('list')) {
                state.roleList.list = data.list;
            }
            if (data.hasOwnProperty('page')) {
                state.roleList.page.per_page = typeof data.page.per_page !== 'undefined' ? data.page.per_page * 1 : state.roleList.page.per_page;
                state.roleList.page.current = typeof data.page.current !== 'undefined' ? data.page.current * 1 : state.roleList.page.current;
                state.roleList.page.total_page = typeof data.page.total_page !== 'undefined' ? data.page.total_page * 1 : state.roleList.page.total_page;
            }
        } else {
            state.roleList.list = [];
            state.roleList.page = {
                per_page: 15,
                current: 1,
                total_page: 1
            };
        }
    },
    ['SET_AUTH_POINT'](state, data) {
        state.authPoints = data ? data : [];
    },
    ['SET_EDITOR_BASE'](state, data) {
        state.editorBases = data.list;
    },
    ['UPDATE_USER_INFO'](state, id) {
        let lastIndex = _.findLastIndex(state.mockRoles, v => v.id === id);
        state.userInfo = lastIndex !== -1 && state.mockRoles[lastIndex];
    },
    ['SET_DATA_CHANNELS'](state, data) {
        state.dataChannels.list = _.map(data.user_data, item => {
            return {
                realname: item.channel_name,
                name: item.channel,
            }
        });
    },
    ['SET_DATA_CHANNEL_GROUPS'](state, data) {
        state.dataChannelGroups.list = data.list;
    },
    ['SET_FIELDS_SUITE'](state, data) {
        state.fieldsSuite = data.list;
    },
    ['SET_ENVIR_VERSION'](state, data){
        state.envirVersion = data;
    }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js